export function getColorForValue(value: number): string {
    // Define color codes - more muted shades
    const blue = [75, 112, 216];
    const yellow = [255, 224, 130];
    const red = [220, 90, 90];

    let startColor, endColor, t;

    if (value < 10) {
        return `rgb(${blue[0]}, ${blue[1]}, ${blue[2]})`; // directly return muted blue
    } else if (value >= 300) {
        return `rgb(${red[0]}, ${red[1]}, ${red[2]})`; // directly return muted red
    } else if (value < 155) {
        startColor = blue;
        endColor = yellow;
        // Normalizing the value to the range [0,1] for interpolation
        t = (value - 10) / 145; 
    } else {
        startColor = yellow;
        endColor = red;
        t = (value - 155) / 145; 
    }

    // Calculate interpolated color value
    const r = (1 - t) * startColor[0] + t * endColor[0];
    const g = (1 - t) * startColor[1] + t * endColor[1];
    const b = (1 - t) * startColor[2] + t * endColor[2];

    return `rgb(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)})`;
}

export const stringToColor = (str: string): string => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const character = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + character;
      hash = hash & hash; // Convert to 32bit integer
    }
    // Use HSL to generate a bright color
    // Hue is determined by the text's hash
    // Saturation is set to 75% for vibrancy
    // Lightness is set to 80% to ensure brightness without being too light
    const color = `hsl(${hash % 360}, 75%, 80%)`;
    return color;
};

export const defaultColorMap = {
    0: '#384b7f',
    1: '#11b2f3',
    2: '#ff6a6c',
    3: '#a1a1a1',
    4: '#32cd5d',
    5: '#2187d0',
    6: '#8d34ff',
    7: '#83f3fb',
    8: '#f6d45d',
    9: '#f2cfcf',
    10: '#f39a13',
    11: '#f20d0d',
};

export const stringToColorDefault = (str: string): string => {
    let hash = 5381; // Initialize with a prime number
    for (let i = 0; i < str.length; i++) {
        const character = str.charCodeAt(i);
        hash = ((hash << 5) + hash) + character; // hash * 33 + character
    }

    // Ensure the hash is positive and map it to the color index
    const colorIndex = Math.abs(hash) % Object.keys(defaultColorMap).length;
    return defaultColorMap[colorIndex as keyof typeof defaultColorMap];
};

export const colorScaleOptions = [
    { label: "Default", value: "Default"},   
    { label: "Viridis", value: "Viridis"},
    { label: "Inferno", value: "Inferno"},
];

export const colorScaleMap: ColorScaleMap = {
    Default: [[0, '#3a4c80'],[0.5, 'white'],[1, '#c00000']],
    Viridis: "Viridis",
    // Inferno:  [[0, '#1703cb'], [0.5, '#bb3755'], [1, '#f6d645']]
    Inferno:  [[0, '#170c3b'], [0.125, '#420a68'], [0.25, '#6b176e'], [0.375, '#932667'], [0.5, '#bb3755'], [0.625, '#dd513a'], [0.75, '#f3771a'], [0.875, '#fca50a'], [1, '#fcffa3']]
    // Inferno:  "Inferno"
};